var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"item":_vm.item,"hide-label":_vm.icon,"label":_vm.$t('users.show_points'),"icon":"mdi-bitcoin","color":"success","text":""},on:{"click":_vm.showPoints}})}
var staticRenderFns = []

export { render, staticRenderFns }